export const Color = {
    URLAUB : '#7C7C7C',
    REMOTE : '#0DD03F',
    EXTERN : '#00A9DC',
    VORORT : '#ff2600',
}
